var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialKakaoRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.552 12.5c-4.861 0-8.802 3.108-8.802 6.942 0 2.479 1.648 4.654 4.126 5.882-.135.465-.867 2.992-.896 3.19 0 0-.017.15.08.207.096.057.21.013.21.013.276-.039 3.21-2.1 3.719-2.459.507.072 1.03.11 1.563.11 4.861 0 8.802-3.109 8.802-6.943 0-3.834-3.94-6.942-8.802-6.942z",
    fill: "#482927"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}
export default SvgSocialKakaoRound;